import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/properties-collections`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/properties-collections/${id}?include=organization,owners,allowedLocations,createdBy,updatedBy,paymentReceivedBy,registrationDivision`, options)
    .then((response) => {
      let product = jsona.deserialize(response.data);
      delete product.links;
      return product;
    });
}

function add(product) {
  const payload = jsona.serialize({
    stuff: product,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties-collections`, payload, options).then((response) => {
    return jsona.deserialize(response.data);
  });
}

function update(product) {
  const payload = jsona.serialize({
    stuff: product,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/properties-collections/${product.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/properties-collections/${id}`, options);
}


function importProperties(payload) {

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/properties-collections/import-properties-collections`, payload, options)
    .then((response) => {
      return response.data;
    });
}


function approve(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties-collections/approve`,data, options);
}

function printPdfLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties-collections/print-letters`, data, options);
}

function printSelectedPdfLetters(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/properties-collections/print-selected-letters`, data, options);
}

function setToPay(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.post(`${url}/properties-collections/set-to-pay`,data, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  importProperties,
  approve,
  printPdfLetters,
  printSelectedPdfLetters,
  setToPay
};
